export default {
  location: state => state.location,
  network: state => state.network,
  technology: state => state.technology,
  technologies: state => {
    if (state.network && state.staticData && state.staticData.technologies) {
      return state.network.technologies.reduce((a, v) => {
        a.push(state.staticData.technologies.find(t => t.name === v));
        return a;
      }, []);
    } else return [];
  },
  networks: state => {
    if (state.staticData && state.staticData.operators) {
      return state.staticData.operators;
    } else return [];
  },
  networkName: state => {
    if (state.network && state.network.name) {
      return state.network.name;
    } else return null;
  },
  technologyName: state => {
    if (state.technology && state.technology.name) {
      return state.technology.name;
    } else return null;
  },
  legend: state => state.legend,
  locationAddress: state => {
    let loc = state.location;
    if (loc && loc.address) return loc.address;
    else return '';
  },
  locationPlaceId: state => {
    let loc = state.location;
    if (loc && loc.placeId) return loc.placeId;
    else return null;
  },
  disclaimer: state => state.disclaimer,
  faq: state => state.faq,
  tooltip: state => key => {
    if (state.staticData && state.staticData.tooltips) {
      let tooltip = state.staticData.tooltips.find(elem => {
        return elem.element === key;
      });
      return tooltip ? tooltip.text : '';
    } else return null;
  },
  globalBoundingBox: state => {
    if (state.staticData && state.staticData.globalBb) {
      return state.staticData.globalBb;
    } else return null;
  },
  currentCoverage: state => state.currentCoverage,
  bounds: state => state.bounds,
  zoom: state => state.zoom,
  listMessages: state => {
    if (state.staticData && state.staticData.messages) {
      return state.staticData.messages;
    } else return [];
  },
  locationCoverageList: state => {
    return state.locationCoverage.items
  },
  locationCoverageModalState: state => {
    return state.locationCoverage.isOpen
  }
};
